<p-timeline [value]="trackings" styleClass="hide-oposite tracking-timeline">
    <ng-template pTemplate="content" let-event>
        <b>{{getActionDescription(event.action)}}</b>
        <small>{{event.message}}</small><br>
        <small>{{event.user?.name}}</small><br>
        <small>{{event.date | date:'dd/MM/yy HH:mm':'GMT'}}</small>
    </ng-template>
</p-timeline>
<div *ngIf="trackings.length==0">
    No se han encontrado información de tracking para esta entidad.
</div>